import { createContext, useContext } from 'react'

import type { GuideTourContextValue } from './types'

export const GuideTourContext = createContext<GuideTourContextValue | null>(
  null
)

export const useGuideTour = (): GuideTourContextValue => {
  const context = useContext(GuideTourContext)

  if (!context) {
    throw new TypeError('useGuideTour must be used within a GuideTourProvider')
  }

  return context
}
